import { t as tt } from 'svelte-i18n';
import { readable, type Readable } from 'svelte/store';
import sanitizeHtml_ from 'sanitize-html';

type MessageFormatter = typeof tt extends Readable<infer T> ? T : never;

export function sanitizeHtml(dirty: string) {
	const cleaned = sanitizeHtml_(dirty, {
		transformTags: {
			a: () => {
				return {
					tagName: 'span',
					attribs: {
						class: 'translation-link'
					}
				};
			}
		},
		allowedClasses: {
			span: ['translation-link']
		},
		allowedTags: ['b', 'i', 'u', 'span', 'em', 'strong']
	});

	return (
		cleaned
			// Replace newlines with <br> tags. \n! is used to force <br> to render even in xs.
			.replace(/\n!/g, '<br style="display: block !important">')
			.replace(/\n/g, ' <br> ')
	);
}

function wrapT(): typeof tt {
	return readable<MessageFormatter>(undefined, (set) => {
		const unsubscribe = tt.subscribe((formatter) => {
			if (formatter) {
				set((...args: Parameters<MessageFormatter>) => {
					const result = formatter(...args);
					const cleaned = sanitizeHtml(result);
					return cleaned;
				});
			}
		});

		return unsubscribe;
	});
}

export const t = wrapT();
